import { EINREICHUNG_STORE_KEY } from '../reducers';
import { EinreichungState } from '../reducers/einreichung.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const getEinreichungState = createFeatureSelector<EinreichungState>(EINREICHUNG_STORE_KEY);
export const selectGalleryItems = createSelector(getEinreichungState, (state: EinreichungState) => state.gallery.items);
export const selectWithThumbnails = createSelector(
  getEinreichungState,
  (state: EinreichungState) => state.gallery.withThumbnails,
);
